// Sanity content API endpoint for the field guide list.
// Shared between App.js (initial load) and offlineSync.js (offline caching).
const PROJECT_ID = 'aptonmyu'
const DATASET = 'production'
const QUERY = encodeURIComponent('*[_type == "fieldguide"]')

// On tailnet (*.ts.net) hosts the Sanity CORS allowlist blocks us, so go
// through the same-origin /sanity-proxy route provided by e2e/server.mjs.
const useProxy =
  typeof window !== 'undefined' && window.location.hostname.endsWith('.ts.net')

const API_BASE = useProxy ? '/sanity-proxy' : `https://${PROJECT_ID}.api.sanity.io`

export const SANITY_URL = `${API_BASE}/v2021-10-21/data/query/${DATASET}?query=${QUERY}`
